import { ActionMessageType } from "@layerswap/widget/types";
import { sendTransaction } from '@wagmi/core';
import { isMobile } from "@layerswap/widget/internal";
import { resolveError } from "../evmUtils/resolveError";
export function createEVMTransferProvider(config, supportsNetwork, buildTransaction) {
    return {
        supportsNetwork,
        async executeTransfer(params) {
            const { selectedWallet } = params;
            try {
                const tx = await buildTransaction(params);
                if (isMobile() && selectedWallet?.metadata?.deepLink) {
                    window.location.href = selectedWallet.metadata.deepLink;
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
                const hash = await sendTransaction(config, tx);
                if (hash) {
                    return hash;
                }
                throw new Error("No transaction hash returned");
            }
            catch (error) {
                const transactionResolvedError = resolveError(error);
                const e = new Error();
                e.message = error instanceof Error ? error.message : String(error);
                if (transactionResolvedError && transactionResolvedError === "insufficient_funds") {
                    e.name = ActionMessageType.InsufficientFunds;
                    throw e;
                }
                else if (transactionResolvedError && transactionResolvedError === "transaction_rejected") {
                    e.name = ActionMessageType.TransactionRejected;
                    throw e;
                }
                else {
                    e.name = ActionMessageType.UnexpectedErrorMessage;
                    throw e;
                }
            }
        }
    };
}
